export default __webpack_public_path__ + "static/DSC_0426-cd7be1b9bab36bb8f15ac5c81fbd915a.jpg";